export default defineNuxtRouteMiddleware((to, from) => {
  const storeRouterHistory = useRouterHistory();

  if (from.fullPath) {
    storeRouterHistory.saveHistory(to.fullPath, from.fullPath);
  }
});
